/* eslint-disable no-magic-numbers */
import $ from 'jquery'
import Vue from 'vue'
import handleErrorStatus from '../proxy/handleErrorStatus'
import { Message } from 'ds-views'

Vue.ucAjaxMap = {}
Vue.ucAbort = Vue.prototype.$ucAbort = () => {
  for (const key in Vue.ucAjaxMap) {
    Vue.ucAjaxMap[key].abort()
    delAjaxMap(Vue, key)
  }
}

// 接口 401 或者未认证的处理方式，跳转到 account 并回调到当前访问地址
function handleUnauthenticated() {
  if (IS_PRODUCTION && window.collectEvent) {
    window.collectEvent('config', {
      user_unique_id: null
    })
  }
  this.$router.push({
    path: '/login',
    query: {
      redirect_url: window.location.href
    }
  })
}

// 判断一个 200 OK 返回的 data 是否是一个旧接口的错误返回
function isErrorInSuccessResponse(responseData) {
  return typeof responseData.success === 'boolean' &&
    typeof responseData.code === 'number' &&
    !responseData.success
}

/**
 *
 * @param {*} ajaxParams
 * @param {*} ajaxOpt
 * @returns Promise
 */
function ucProxy(ajaxParams, ajaxOpt) {
  ajaxOpt = $.extend({
    mock: false, // 是否读取mock数据,开启后url会加上/mock前缀
    noAbort: false, // 默认切换页面会把所有未完成的ajax请求都abort掉,可以指定不abort的请求,比如一些上报接口
    showMeg: true // 是否通过显示错误信息
  }, ajaxOpt)
  if (ajaxOpt.mock) {
    ajaxParams.url = `/mock${ajaxParams.url}`
  }
  return new Promise((resolve, reject) => {
    const ajaxKey = `${ajaxParams.url}?${JSON.stringify(ajaxParams.data)}`
    ajaxParams = Object.assign({
      url: '',
      dataType: 'json',
      type: 'get',
      data: {},
      xhrFields: {
        withCredentials: true
      },
      success: (data) => {
        // 兼容以前的旧接口，statusCode = 200 但其实是出错的
        if (data.code === 2001 || data.code === 1000) {
          handleUnauthenticated()
          reject(data)
        } else if (isErrorInSuccessResponse(data) && ajaxOpt.showMeg) {
          Message({
            type: 'error',
            message: data.msg || data.message || '系统出错啦',
            duration: 1500,
          })
          reject(data)
        } else {
          resolve(data)
        }
      },
      error: (data) => {
        // 虽然调用了 error callback 但 statusCode = 200 表示请求成功
        if (data.status === 200) {
          resolve(true)
          return
        }
        if (data.status === 401) {
          handleUnauthenticated()
          reject(data)
          return
        }
        if (data.statusText !== 'abort') {
          reject(data)
          const familiarResult = handleErrorStatus({
            ...data,
            responseURL: ajaxParams.url,
          })
          if (!familiarResult.success && ajaxOpt.showMeg) {
            Message({
              type: 'error',
              message: `【${familiarResult.code}】 ${familiarResult.message}`,
              duration: 2000,
            })
          }
        }
      },
      complete: (data, error) => {
        delAjaxMap(Vue, ajaxKey)
      }
    }, ajaxParams)
    const jqxhr = $.ajax(ajaxParams)

    if (!ajaxOpt.noAbort) {
      setAjaxMap(Vue, {
        ajaxKey: ajaxKey,
        jqxhr: jqxhr
      })
    }
  })
}
// restful风格api接口，put类型接口成功不返回任何信息
export function ucRestfulProxy(...args) {
  const vm = this
  let obj = {}
  return new Promise((resolve, reject) => {
    if (args[0].type) {
      const methodStr = args[0].type.toLowerCase()
      if (['put', 'post', 'delete'].includes(methodStr)) {
        obj = { contentType: 'application/json' }
        if (args[0].data) {
          args[0].data = JSON.stringify(args[0].data)
        }
      }
    }
    if (args[0].url) {
      args[0].url = `${args[1] && args[1].mock ? 'mock' : ''}/api/v1${args[0].url}`
    }
    ucProxy.call(vm, { ...args[0], ...obj })
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        const errCode1 = 200; const errCode2 = 401
        if (err.status === errCode1) {
          return resolve({})
        } else if (err.status === errCode2) { // 身份认证不存在
          // actions.setGlobalState({ isLoggedOut: true })
          vm.$router.push({ name: 'Login' })
        } else {
          reject(err.responseJSON)
        }
      })
  })
}
export const delAjaxMap = (Vue, ajaxKey) => {
  delete Vue.ucAjaxMap[ajaxKey]
}

export const setAjaxMap = (Vue, config) => {
  Vue.ucAjaxMap[config.ajaxKey] = config.jqxhr
}
export default ucProxy
